/*
 * ALL RIGHTS RESERVED,
 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
 */

import { AuthenticationService } from '../../common/authentication/service/AuthenticationService';
import { PjInjectProxy } from '../../common/extends_fw/PjInjectProxy';
import { PjBaseController, Alert } from '../../common/extends_fw/controller/PjBaseController';
import { PjServiceResponse } from '../../common/extends_fw/service/PjServiceResponse';
import { MsgLevel } from '../../framework/controller/MsgLevel';
import { PasswordService } from '../service/PasswordService';
import { PasswordJson } from '../json/JsonAll';

/**
 * パスワード画面について出力処理およびイベント処理を行う。
 */
export class PasswordController extends PjBaseController {

    // パスワード入力値
    public password: string;

    // パスワード更新情報
    public upPassword: PasswordJson;

    /**
     * コンストラクタ
     */
    /* @ngInject */
    public constructor(
            protected $stateParams: angular.ui.IStateParamsService,
            protected $window: ng.IWindowService,
            protected $uibModal: ng.ui.bootstrap.IModalService,
            protected $translate: ng.translate.ITranslateService,
            protected pjInjectProxy: PjInjectProxy,
            protected passwordService: PasswordService,
            protected $location: ng.ILocationService,
            protected $scope: any) {
        super($stateParams, $translate, $location, pjInjectProxy);

        if (!this.checkAuthenticatedUser()) {
            return;
        }

        this.setTitle('form33.title');
    }

    public updatePassword(): void {
        let pass: any = {
            password: this.password
        };
        this.upPassword = pass;
        this.passwordService.updatePassword(this.upPassword).then((data: any) => {
            this.clearAlert();
            this.setAlert('message.0029');
        }).catch((errorData: any) => {
            this.catch(errorData);
        });
    }

    public passwordChanged(): void {
        this.$scope.$broadcast('angularValidation.revalidate', 'passwordRe');
    }

    /**
     * 復元処理
     * @param {any} data 復元用データ
     */
    public restore(data: any): void {}

    /**
     * 表示処理
     */
    public show(): void {}
}



/** WEBPACK FOOTER **
 ** node_modules/tslint-loader!./src/ma/controller/PasswordController.ts
 **/